<div class="dialog-container" [dir]="localeDirection$ | async">
	<button mat-icon-button class="c-btn-close" [disableRipple]="true" (click)="onClose()">
		<img [src]="'assets/icons/close.svg' | s3Image" alt="close  dialog" />
	</button>

	<ng-container #container></ng-container>

	<button cdkFocusInitial hidden></button>
</div>

<!-- GOOGLE RECAPTCHA INVISIBLE -->
<div id="google-recaptcha-invisible"></div>
